/**
 * What the login and lock screens draw when `/auth/mode` cannot be reached and nothing else
 * has said which way this console signs people in. Neutral on purpose: no passkey button,
 * no keypad, because either one could be the wrong screen. One sentence and a Retry.
 */
import { AUTH_MODE_UNREACHABLE_MESSAGE } from './mode';

export function AuthModeUnreachable({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="a-auth__unreachable" role="status" data-testid="auth-mode-unreachable">
      <p className="a-auth__hint">{AUTH_MODE_UNREACHABLE_MESSAGE}</p>
      <button type="button" className="a-btn" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
}
